import { Family } from "../types";
import ResourceService from "../common/Services/ResourceService";

class FamilyService extends ResourceService<Family> {
  constructor() {
    super({
      path: "/families",
      queryKey: "families",
    });
  }

  static listFamilies() {
    return new FamilyService().list();
  }

  static fetchFamily(id: Family["id"]) {
    return new FamilyService().fetch({ id });
  }

  static createFamily(payload?: Partial<Family>) {
    return new FamilyService().create(payload);
  }

  static updateFamily(id: Family["id"], payload: Partial<Family>) {
    return new FamilyService().update({ ...payload, id });
  }

  static deleteFamily(id: Family["id"]) {
    return new FamilyService().deleteOne({ id });
  }
}

export default FamilyService;
